import { STORAGE_KEYS, getStorageItem, saveStorageItem } from './storage.service';

/**
 * @deprecated Please migrate over to `useAppSettings()` hook
 */
const getEnvironmentSettings = (): { apiBaseUrl: string; buildVersion: string; } => {
    return getStorageItem<{ apiBaseUrl: string; buildVersion: string; }>(STORAGE_KEYS.LegacyEnvSettings, { sessionOnly: true });
};

/**
 * @deprecated Please migrate over to `useAppSettings()` hook
 */
const setEnvironmentSettings = (settings: { apiBaseUrl: string;  buildVersion: string; }) => {
    saveStorageItem(STORAGE_KEYS.LegacyEnvSettings, settings, { sessionOnly: true });
}

const environmentServiceWrapper = {
    getEnvironmentSettings,
    setEnvironmentSettings
};

export default environmentServiceWrapper;